/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenGoal Platform API
 * Agency-facing API — day-to-day platform usage by agency users.
 * OpenAPI spec version: 1.0
 */

export type CreatePlayerDtoPreferredFoot = typeof CreatePlayerDtoPreferredFoot[keyof typeof CreatePlayerDtoPreferredFoot];


export const CreatePlayerDtoPreferredFoot = {
  right: 'right',
  left: 'left',
  both: 'both',
} as const;
